import { KeyboardEvent } from "react";

export const RegexPatterns = Object.freeze({
  email: /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+([a-zA-Z0-9]{2,})$/,
  noNumbers: /[^0-9]/,
  onlyLetters: /[a-zA-Z]/,
  onlyLettersAndNumbers: /[a-zA-Z0-9]/,
  onlyNumbers: /[0-9]/,
});

const test = (pattern: RegExp) => (event: KeyboardEvent) => {
  event.persist();
  const charCode = (typeof event.which === "undefined") ? event.keyCode : event.which;
  const charStr = String.fromCharCode(charCode);

  if (pattern.test(charStr)) {
    return true;
  }

  event.preventDefault();

  return false;
};

export const getOnPreventKeypress = (pattern: RegExp) => test(pattern);
